export const MEDIA_FIELDS = [
  { key: "jobTitle", label: "Pool Title" },
  {
    key: "status",
    label: "status",
    type: "fixed-select",
    options: [
      { value: "active", label: "Active" },
      { value: "not active", label: "Not active" },
    ],
  },
  { key: "startDate", label: "start Date", type: "date" },
  { key: "endDate", label: "end Date", type: "date" },
  {
    key: "taskDetails",
    label: "Task Details",
    type: "file-v2",
  },
  {
    key: "shifts",
    width: 12,
    label: "Shifts",
    type: "add-more-v2",
    schema: {
      name: {},
      price: { type: "number" },
      from: { type: "time" },
      to: { type: "time" },
    },
  },

  {
    key: "workItems",
    width: 12,
    label: "Work Items",
    type: "add-more-v2",
    schema: {
      name: {},
      type: {},
      fee: { type: "number" },
      relevant: {},
      startDate: { type: "date" },
      endDate: { type: "date" },
    },
  },

  { key: "skillRewards", label: "skill Rewards", type: "checkbox" },
  { key: "flex assistance", label: "flex assistance", type: "checkbox" },
];

const FIELDS = [...MEDIA_FIELDS];

export default FIELDS;
